import {AuthType, googleConfig} from '../constants';
import {googleApi} from '../core/google-api';
import * as snapAuth from '../core/snap-auth';
import {log} from '../shared/log';
import {SignUpControl, ui} from '../shared/ui';
import {exceptionToMessage} from '../shared/util';
import {GoogleComponent} from './google.component';

export async function init() {
  try {
    const signInControl = ui.controls.get(AuthType.Google);

    if (signInControl == null) {
      throw new Error(`UI control not found for "${AuthType.Google}".`);
    }

    const $signUp = signInControl.$.querySelector('.form-control__sign-up');

    if ($signUp == null) {
      throw new Error('Sign up button not found.');
    }

    const signUpControl = new SignUpControl($signUp as HTMLButtonElement);

    // Load sdk
    await googleApi.load('client:auth2');

    // Initialize GoogleAuth
    const {googleAuth} = await googleApi.initAuth({
      client_id: googleConfig.CLIENT_ID,
      fetch_basic_profile: false,
      scope: googleConfig.SCOPE,
    });

    return new GoogleComponent(googleAuth, snapAuth, signInControl, signUpControl, ui, log);

  } catch (ex) {
    const message = exceptionToMessage(ex);
    log.warn(message);
    log.sendError(message);
    throw new Error(message);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/google.ts